import Tree from './Tree'
export { withSearchContext } from './searchContext'
export default Tree
